<ng-container>
    <span class="d-flex justify-content-center align-items-center mb-2 font-weight-bold"
        style="color: #017078; font-size: 17px;"
    >
        {{ 'maintenance_time' | translate }}
    </span>
    <div class="timer d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column timer-box">
            <span id="days" class="font-weight-bold"> 
                {{daysToDay.toLocaleString(undefined,{minimumIntegerDigits: 2})}} 
            </span>
            <small> {{ 'maintenance_day' | translate }}</small> 
        </div>
        <div class="d-flex flex-column timer-box">
            <span id="hours" class="font-weight-bold"> 
                {{hoursToDday.toLocaleString(undefined,{minimumIntegerDigits: 2})}} 
            </span>
            <small> {{ 'maintenance_hr' | translate }}</small> 
        </div>
        <div class="d-flex flex-column timer-box gy-3">
            <span id="minutes" class="font-weight-bold"> 
                {{minutesToDday.toLocaleString(undefined,{minimumIntegerDigits: 2})}} 
            </span>
            <small> {{ 'maintenance_min' | translate }}</small> 
        </div>
        <div class="d-flex flex-column timer-box">
            <span id="seconds" class="font-weight-bold"> 
                {{secondsToDday.toLocaleString(undefined,{minimumIntegerDigits: 2})}} 
            </span>
            <small> {{ 'maintenance_sec' | translate }}</small> 
        </div>
    </div>  
</ng-container>